import { STORAGE_ITEMS } from "../services/constants";
import { StorageService } from "../services/StorageService";

function checkSessionChanged(item, key = "sessionId") {
  if (item[key] === StorageService.getSessionId()) return false;

  return true;
}

function appendSessionKey(item, key = "sessionId") {
  const sessionId = StorageService.getSessionId();

  const obj = { item, sessionId };
  return obj;
}

export { checkSessionChanged, appendSessionKey };
